






































import {Component, Prop, Vue } from 'vue-property-decorator';
import { Debounce } from 'vue-debounce-decorator';

import { TagsFilterState } from "@share/program/components/parallel-agendas/filter/TagsFilterState"

import AgendaFilterDateSwitcher from '@share/date-switcher/AgendaFilterDateSwitcher.vue'
import FilterButton from "@share/common/FilterButton.vue";
import TagList from "@share/common/tag-list/TagList.vue";
import FilterModal from "@share/committees/committees-list/components/filter/filter-modal/FilterModal.vue";
import { SelectableTag } from '@api/models/SelectableTag';
import SearchInput from "@share/common/search-input/SearchInput.vue";
import AgendaFilterTZ from "@share/program/components/parallel-agendas/filter/AgendaFilterTZ.vue";
import { SelectableTagInterface } from '@api/models/interfaces/SelectableTagInterface';
import { TicketType } from '@share/ticketSystem/enums/TicketTypes';
import { ModalFilterState } from '@share/committees/committees-list/types/filterTypes';

@Component({
    components: { TagList, AgendaFilterDateSwitcher, FilterModal, FilterButton, SearchInput, AgendaFilterTZ }
})
export default class CommitteeFilter extends Vue {

    @Prop({ default: () => [] }) selectedTagsIds: string[];

    @Prop() keyword: string;
    @Prop() type: string;
    @Prop() selectedTimeZone: string;
    @Prop() tags: SelectableTagInterface[];

    showModal = false;
    date = null;
    subjectType: TicketType | "all" = "all";

    tagsFilterState: TagsFilterState | null = null;

    datePickerSide = "";

    onTZChange(selectedTimeZone: string) {
        this.$emit('filterTz', selectedTimeZone);
    }

    mounted() {
        this.tagsFilterState = new TagsFilterState(this.tags, "filterTags");

        this.setDatePickerSide();
    }

    @Debounce(40)
    setDatePickerSide() {
        // is this useless?
        this.datePickerSide = window.innerWidth >= 1024 ? 'right' : '';
    }

    activated() {
        window.addEventListener('resize', this.setDatePickerSide)
    }

    deactivated() {
        window.removeEventListener('resize', this.setDatePickerSide)
    }

    onSearchInput(keyword: string) {
        this.$emit("filterKeyword", keyword);
    }

    get searchPlaceholder() {
        return this.$t("agenda.searchByName").toString();
    }

    get tagsForModal() {
        return this.tagsFilterState?.tags || [];
    }

    get showTagsButtons() {
        return !!this.tags.length;
    }

    showFiltersModal() {
        this.showModal = true;
        this.tagsFilterState?.setTags();
    }

    applyFilters() {

        const data: ModalFilterState = {
            subjectType: this.subjectType,
            tagsIds: this.tagsFilterState?.acumulatedTagsIds.map(item => item)
        }

        this.$emit("filterTagsOrSubject", data);

        this.showModal = false;

        this.$nextTick(() => {
            this.setTags();
        });
    }

    accumulateTag(eventItem: SelectableTag) {
        this.tagsFilterState?.accumulateTag(eventItem);
    }

    resetFilters() {
        this.tagsFilterState?.clear();
        this.subjectType = "all";
        this.applyFilters();
    }

    setTags() {
        this.tagsFilterState?.updateSource(this.tags, null, this.selectedTagsIds);
    }
}

